import * as t from "react";
import { env as f } from '../utils/env.js';
function s() {
  let r = typeof document == "undefined";
  return "useSyncExternalStore" in t ? (o => o.useSyncExternalStore)(t)(() => () => {}, () => !1, () => !r) : !1;
}
function l() {
  let r = s(),
    [e, n] = t.useState(f.isHandoffComplete);
  return e && f.isHandoffComplete === !1 && n(!1), t.useEffect(() => {
    e !== !0 && n(!0);
  }, [e]), t.useEffect(() => f.handoff(), []), r ? !1 : e;
}
export { l as useServerHandoffComplete };